import { getUserInfo, login } from '@/api/user'
import type { LockInfo, LoginParam, NavTab, UserInfo } from '@/types/user'
import { setItem } from '@/utils/storage'
import { defineStore } from 'pinia'

// 你可以对 `defineStore()` 的返回值进行任意命名，但最好使用 store 的名字，同时以 `use` 开头且以 `Store` 结尾。(比如 `useUserStore`，`useCartStore`，`useProductStore`)
// 第一个参数是你的应用中 Store 的唯一 ID。
export const useUserInfoStore = defineStore('userInfo', {
  state: () => {
    // 用户信息
    return {
      user: {} as UserInfo,
      collapse: false, // 菜单折叠状态
      lockInfo: { password: '', isLockScreen: false } as LockInfo,
      tabList: [] as NavTab[]
    }
  },
  getters: {
    avatar: (state) => {
      return state.user.avatar || '/images/avatar_boy.jpeg'
    }
  },
  actions: {
    // 登录获取token
    async login(loginForm: LoginParam) {
      console.log('登录获取token')
      const token = await login(loginForm)
      console.log('开始设置token', token)
      setItem('token', token)
    },
    // 获取用户信息
    async getUserInfo() {
      console.log('获取用户信息')
      this.user = await getUserInfo()
    },

    // 退出登录
    async logout() {
      // 请求后端接口
      // await logout()
      // 清除数据和状态
      window.localStorage.clear()
      this.$reset()
    },

    // 切换菜单折叠状态
    switchFolding() {
      this.collapse = !this.collapse
    }
  },

  persist: true
})
